import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ajustes-generales',
    templateUrl: './ajustes-generales.component.html',
    styleUrls: ['./ajustes-generales.component.css'],
    standalone: false
})
export class AjustesGeneralesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
